import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
    @Input() value: string = '';
    @Input() customClass: string = '';
    @Input() customIcon: string = '';
    
}
